// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ClipboardCheck as RawClipboardCheck } from "lucide-react";
export const ClipboardCheck = /* @__PURE__ */ createIcon(RawClipboardCheck, "ClipboardCheck", 2);
